<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="floppy-save"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g id="Group_1069" data-name="Group 1069" transform="translate(2.255 2.25)">
      <path
        id="Path_8492"
        data-name="Path 8492"
        d="M12.875,3H4.507a1.5,1.5,0,0,0-1.5,1.511l.078,10.5a1.5,1.5,0,0,0,1.5,1.489H15A1.5,1.5,0,0,0,16.5,15V6.621a1.5,1.5,0,0,0-.44-1.061L13.935,3.44A1.5,1.5,0,0,0,12.875,3Z"
        transform="translate(-3.007 -3)"
        fill="none"
        :stroke="clr ? clr : '#768391'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8493"
        data-name="Path 8493"
        d="M13.745,3V5.932a.75.75,0,0,1-.75.75h-4.5a.75.75,0,0,1-.75-.75V3M7,16.5V10.715a.965.965,0,0,1,.965-.965h5.572a.965.965,0,0,1,.964.965V16.5"
        transform="translate(-4.005 -3)"
        fill="none"
        :stroke="clr ? clr : '#768391'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8494" data-name="Path 8494" d="M0,0H18V18H0Z" fill="none" />
  </svg>
</template>
<style scoped>
path {
  transition: all 0.5s ease-out 0.5s;
}
</style>
